import "./TestDetailsAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import {Field, FieldProps, Form, Formik, FormikHelpers, FormikProps, FormikValues} from "formik";
import React, {useCallback, useEffect, useRef, useState} from "react";
import Grid from "@mui/material/Grid";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import * as Yup from "yup";
import CommonService from "../../../../shared/services/common.service";
import FormikSelectDropdownComponent
    from "../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {useDispatch, useSelector} from "react-redux";
import {getSampleTypesWithCollectionDevices} from "../../../../store/actions/staticData.action";
import commonService from "../../../../shared/services/common.service";
import {ImageConfig} from "../../../../constants";

interface TestDetailsAddComponentProps {
    testID?: number;
    next: Function;
    cancel: Function;
    testDetails?: any;
}

const testDetailsAddFormValidationSchema = Yup.object({
    name: Yup.string().required("Test Name is Required")
        .max(50, "Test Name should be less than 50 characters"),
    code: Yup.string().required("Test Code is Required")
        .min(4, "Test Code should be Minimum 4 characters")
        .max(4, "Test Code should be Maximum 4 characters"),
    sampleType: Yup.mixed().required("Sample Type Required"),
    sampleQuantity: Yup.string().required("Sample Quantity is Required"),
    // description: Yup.string()
    //     .max(200, "Comments should be less than 200 characters"),
    sampleCollectionDeviceName: Yup.mixed().required("Sample Collection Device Name is Required"),
    biomarkerIds: Yup.array().of(Yup.string()).required("Biomarker is Required"),
    // isStateReportingRequired: Yup.boolean().required("State Reporting is required"),
    // // reportingSchedule: Yup.mixed().when("IsStateReportingRequired", {
    // //     is: (IsStateReportingRequired: boolean) => {
    // //         return IsStateReportingRequired
    // //     },
    // //     then: Yup.mixed().nullable().required("Resulting Mode is required"),
    // // }),
    // isBulkImportRequired: Yup.boolean().required("State Reporting is required"),
    // bulkImportTemplate: Yup.mixed().when("IsStateReportingRequired", {
    //     is: (IsStateReportingRequired: boolean) => {
    //         return IsStateReportingRequired
    //     },
    //     then: Yup.mixed().nullable().required("Resulting Mode is required"),
    // }),
    // ResultTemplate: Yup.mixed().required('Required'),
    resultingMode: Yup.mixed().required("Resulting Mode is required"),
});

interface testDetailsAddFormSchema {
    name: string;
    code: string;
    sampleType: string;
    sampleCollectionDeviceName: string;
    // description: string;
    biomarkerIds: string[];
    sampleQuantity?: string;
    resultingMode?: string;
}

const FormInitialValues: testDetailsAddFormSchema = {
    name: "",
    code: "",
    sampleType: "",
    sampleCollectionDeviceName: "",
    // description: "",
    biomarkerIds: [],
    sampleQuantity: undefined,
    resultingMode: undefined,
}

const TestDetailsAddComponent = (props: TestDetailsAddComponentProps) => {
    const {next, cancel, testID, testDetails} = props
    const [testDetailsAddFormInitialValues, setTestDetailsAddFormInitialValues] = useState<testDetailsAddFormSchema>(FormInitialValues);
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const dispatch = useDispatch();
    const {sampleTypeWithCollectionDevices} = useSelector((state: any) => state.staticData);
    const [biomarkerList, setBiomarkerList] = useState<any[]>([]);
    const [isBiomarkerListLoading, setIsBiomarkerListLoading] = useState<boolean>(false);
    const [isBiomarkerListLoadingError, setIsBiomarkerListLoadingError] = useState<boolean>(false);
    const [isBiomarkerListLoaded, setIsBiomarkerListLoaded] = useState<boolean>(false);

    const onTestAdd = useCallback((values: any, {setSubmitting, setErrors, validateForm}: FormikHelpers<any>) => {
        if (!testID) {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to continue adding this test?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: "Continue",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            }).then(() => {
                setSubmitting(true);
                CommonService._test.addNewTest(values)
                    .then((response: IAPIResponseType<any>) => {
                        setSubmitting(false);
                        next(response?.data?.id, response?.data);
                    })
                    .catch((error: any) => {
                        CommonService.handleErrors(setErrors, error);
                        setSubmitting(false);
                    });
            }).catch(() => {
                setSubmitting(false);
            })
        } else {
            setSubmitting(true);
            CommonService._test.editTestDetails(testID, values)
                .then((response: IAPIResponseType<any>) => {
                    setSubmitting(false);
                    next(testID, response?.data);
                })
                .catch((error: any) => {
                    CommonService.handleErrors(setErrors, error);
                    setSubmitting(false);
                });
        }
    }, [next, testID]);

    const getBiomarkerList = useCallback((sampleType: String, sampleCollectionDeviceName: string) => {
        setIsBiomarkerListLoading(true);
        setIsBiomarkerListLoadingError(false);
        CommonService._test.getBiomarkerList(sampleType, sampleCollectionDeviceName)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    setBiomarkerList(response.data);
                }
                setIsBiomarkerListLoading(false);
                setIsBiomarkerListLoaded(true);
            })
            .catch((error: any) => {
                setIsBiomarkerListLoading(false);
                setIsBiomarkerListLoadingError(true);
            });
    }, []);

    useEffect(() => {
        // dispatch(getSampleTypesList())
        dispatch(getSampleTypesWithCollectionDevices())
    }, [dispatch])

    // const handleTemplateAttachmentUpload = useCallback((fieldName: any, event: any) => {
    //     const file = event?.target?.files[0];
    //     const maxAllowedSize = 5 * 1024 * 1024;
    //     if (event?.target?.files[0].size > maxAllowedSize) {
    //         CommonService._alert.showToast('File size should be under 5MB.', "error");
    //         event.target.value = null;
    //         event.target.files = null;
    //         return;
    //     }
    //     event.target.value = null;
    //     event.target.files = null;
    //
    //     if (fieldName === 'ResultTemplate') {
    //         if (formikRef.current) {
    //             formikRef.current.setFieldValue('ResultTemplate', file);
    //         }
    //     } else {
    //         if (formikRef.current) {
    //             formikRef.current.setFieldValue('bulkImportTemplate', file);
    //         }
    //     }
    // }, []);

    useEffect(() => {
        if (testDetails) {
            getBiomarkerList(testDetails?.sampleType, testDetails?.sampleCollectionDeviceName);
            setTestDetailsAddFormInitialValues(testDetails)
        }
    }, [testDetails, getBiomarkerList]);

    return (
        <div className="test--details-add-screen screen t-form-screen">
            <FormTitleWithNavigationBack
                title={'Basic Details'}
                tooltipData={"Ensure that the name of the Test is unique. The auto-generated report will use a pre-defined template, whereas manual upload will need you to manually upload all results."}
            />
            <div className="t-form">
                <Formik
                    validationSchema={testDetailsAddFormValidationSchema}
                    initialValues={testDetailsAddFormInitialValues}
                    validateOnChange={true}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    innerRef={formikRef}
                    onSubmit={onTestAdd}
                >
                    {({isSubmitting, values, isValid, setFieldValue, touched, errors, validateForm}) => {
                        return (
                            <Form className={"test--details-add-holder"}>
                                <div className="t-form-controls-wrapper">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'name'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Test Name'}
                                                            placeholder={'Enter Test Name'}
                                                            type={"text"}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'code'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Test Code'}
                                                            placeholder={'Enter Test Code'}
                                                            maxLength={4}
                                                            type={"text"}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'sampleType'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Sample Type'}
                                                            options={sampleTypeWithCollectionDevices}
                                                            placeholder={'Select Sample Type'}
                                                            valueKey={'sampleType'}
                                                            required={true}
                                                            getOptionLabel={(option) => (commonService.capitalizeFirstLetter(option.sampleType)) || ''}
                                                            onUpdate={(value: any) => {
                                                                setFieldValue('sampleCollectionDeviceName', '');
                                                                setFieldValue('biomarkerIds', []);
                                                            }
                                                            }
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'sampleCollectionDeviceName'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Sample Collection Device Name'}
                                                            placeholder={'Select Sample Collection Device Name'}
                                                            options={commonService.extractCollectionDevicesFromSampleType(values?.sampleType, sampleTypeWithCollectionDevices)}
                                                            valueKey={'code'}
                                                            required={true}
                                                            getOptionLabel={(option) => (commonService.capitalizeFirstLetterOfEachWord(option.title)) || ''}
                                                            onUpdate={(value: any) => {
                                                                setFieldValue('biomarkerIds', []);
                                                                if (value && values?.sampleType) {
                                                                    getBiomarkerList(values?.sampleType, value);
                                                                }
                                                            }
                                                            }
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'sampleQuantity'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Sample Quantity'}
                                                            placeholder={'Enter Sample Quantity'}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'biomarkerIds'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Select Biomarker(s)'}
                                                            options={biomarkerList}
                                                            multiple={true}
                                                            placeholder={'Select Biomarkers(s)'}
                                                            valueKey={'id'}
                                                            isDataLoading={isBiomarkerListLoading}
                                                            isDataLoadingFailed={isBiomarkerListLoadingError}
                                                            isDataLoaded={isBiomarkerListLoaded}
                                                            required={true}
                                                            getOptionLabel={(option) => commonService.capitalizeFirstLetterOfEachWord(option.name)}
                                                            formikField={field}/>
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'resultingMode'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Select Resulting Mode'}
                                                            options={commonService._staticData.testResultingMode}
                                                            placeholder={'Select Resulting Mode'}
                                                            valueKey={'code'}
                                                            required={true}
                                                            getOptionLabel={(option) => option?.title}
                                                            formikField={field}/>
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    {/*<Field name={'description'}>*/}
                                    {/*    {*/}
                                    {/*        (field: FieldProps) => (*/}
                                    {/*            <FormikInputComponent*/}
                                    {/*                label={'Description (if any)'}*/}
                                    {/*                placeholder={'Enter Description'}*/}
                                    {/*                type={"text"}*/}
                                    {/*                required={false}*/}
                                    {/*                multiline={true}*/}
                                    {/*                rows={3}*/}
                                    {/*                formikField={field}*/}
                                    {/*            />*/}
                                    {/*        )*/}
                                    {/*    }*/}
                                    {/*</Field>*/}

                                </div>

                                <div className="form-action-section">
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        disabled={isSubmitting}
                                        handleClick={cancel}
                                    >
                                        Cancel
                                    </ButtonComponent>
                                    <ButtonComponent

                                        type="submit"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={true}
                                        disabled={!isValid}
                                        isLoading={isSubmitting}
                                    >
                                        Proceed
                                    </ButtonComponent>
                                </div>

                            </Form>
                        )
                    }
                    }
                </Formik>
            </div>
        </div>
    );

};

export default TestDetailsAddComponent;
